export default "__VITE_ASSET__B98tuWG3__"